import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import computerAuthService from "../services/computerAuthService";


const ComputerDashboard = () => {
  const navigate = useNavigate();
  const [computer, setComputer] = useState(() => computerAuthService.getComputer());
  const [showDisclaimer, setShowDisclaimer] = useState(() => {
    return sessionStorage.getItem("pc_disclaimer_accepted") !== "true";
  });

  useEffect(() => {
    let active = true;
    const loadComputerProfile = async () => {
      try {
        const response = await computerAuthService.getProfile();
        if (active && response?.success && response?.computer) {
          setComputer(response.computer);
        }
      } catch (error) {
        console.error("Computer profile error:", error);
      }
    };
    loadComputerProfile();
    return () => { active = false; };
  }, []);

  const handleLogout = () => {
    sessionStorage.clear();
    toast.success("Logged out successfully");
    navigate("/login");
  };

  const handleAcceptDisclaimer = () => {
    sessionStorage.setItem("pc_disclaimer_accepted", "true");
    setShowDisclaimer(false);
  };

  const openGame = () => {
    navigate("/game");
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;700;900&display=swap');
        .sparkle-bg {
          position: fixed;
          inset: 0;
          z-index: 0;
          overflow: hidden;
          background: 
            radial-gradient(ellipse at 50% 0%, #800000 0%, transparent 50%),
            radial-gradient(circle at 50% 120%, #b300ff 0%, #1a0033 40%, #000000 100%);
          pointer-events: none;
        }

        .sparkle {
          position: absolute;
          width: 3px;
          height: 3px;
          background: white;
          border-radius: 50%;
          box-shadow: 0 0 5px 1px white;
          animation: twinkle 3s infinite;
        }

        @keyframes twinkle {
          0%, 100% { opacity: 0.1; transform: scale(0.5); }
          50% { opacity: 1; transform: scale(1.5); }
        }


        .game-item {
          transition: transform 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          cursor: pointer;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .game-item:hover {
          transform: scale(1.08);
        }

        .game-icon-container {
          width: 140px;
          height: 140px;
          border-radius: 50%;
          border: 4px solid #ffcc00;
          overflow: hidden;
          box-shadow: 0 5px 15px rgba(0,0,0,0.8);
          background: #111;
        }
        
        .game-icon {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .game-label {
          background: linear-gradient(180deg, #ffe066, #f5af19);
          border: 2px solid #fff;
          border-radius: 10px;
          padding: 6px 10px;
          margin-top: -15px;
          color: #900;
          font-weight: 900;
          font-size: 13px;
          z-index: 1;
          box-shadow: 0 4px 6px rgba(0,0,0,0.6);
          text-align: center;
          width: 140px;
          line-height: 1.1;
        }

        /* Top Bar Text */
        .top-label {
          font-size: 22px;
          font-weight: bold;
          color: #ffcc00;
          margin-right: 8px;
          text-shadow: 2px 2px 4px #000;
          white-space: nowrap;
        }

        .top-value {
          background: linear-gradient(90deg, #ff4e00, #ec9f05);
          padding: 4px 18px;
          border-radius: 6px;
          font-weight: 900;
          color: #111;
          font-size: 18px;
          min-width: 130px;
          text-align: center;
          box-shadow: 0 2px 5px rgba(0,0,0,0.5);
          word-break: break-all;
        }

        .top-bar-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 15px 30px;
          z-index: 10;
          gap: 15px;
          flex-wrap: wrap;
        }

        .top-info-group {
          display: flex;
          gap: 20px;
          align-items: center;
          flex-wrap: wrap;
        }

        .top-actions-group {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          gap: 12px;
        }

        .games-grid-card {
          border: 2px solid #ffcc00;
          border-radius: 30px;
          padding: 45px 30px;
          width: 95%;
          max-width: 1300px;
          background: linear-gradient(180deg, #c20808 0%, #8c0303 100%);
          display: flex;
          flex-direction: column;
          gap: 35px;
          align-items: center;
          box-shadow: 0 0 50px 10px rgba(255, 215, 0, 0.6), 0 0 100px 30px rgba(255, 60, 0, 0.4);
        }

        .games-row-container {
          display: flex;
          justify-content: center;
          gap: 35px;
          flex-wrap: wrap;
          width: 100%;
        }

        .disclaimer-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 10px;
          margin-bottom: 10px;
        }

        /* Responsive Media Queries */
        @media (max-width: 768px) {
          .top-bar-container {
            padding: 12px 14px;
            gap: 12px;
          }

          .top-info-group {
            width: 100%;
            justify-content: space-between;
            gap: 10px;
          }

          .top-actions-group {
            width: 100%;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
          }

          .top-label {
            font-size: 15px;
            margin-right: 5px;
          }

          .top-value {
            font-size: 14px;
            padding: 4px 10px;
            min-width: 90px;
          }

          .games-grid-card {
            padding: 24px 16px;
            border-radius: 20px;
            box-shadow: 0 0 25px 5px rgba(255, 215, 0, 0.4);
            display: flex !important;
            flex-direction: column !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 28px !important;
            width: 100% !important;
            max-width: 420px !important;
            box-sizing: border-box;
          }

          /* Unwrap desktop row wrappers so each game sits in 1 vertical column */
          .games-row-container {
            display: flex !important;
            flex-direction: column !important;
            align-items: center !important;
            gap: 28px !important;
            width: 100% !important;
          }

          .game-item {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
          }

          .game-icon-container {
            width: 130px;
            height: 130px;
            border-width: 4px;
          }

          .game-label {
            width: 145px;
            font-size: 13px;
            padding: 6px 12px;
            margin-top: -15px;
          }

          .disclaimer-grid {
            grid-template-columns: 1fr;
          }

          .royal-modal-card {
            padding: 16px 14px !important;
            max-height: 90vh;
            overflow-y: auto !important;
          }
        }

        @media (max-width: 480px) {
          .top-info-group {
            flex-direction: column;
            align-items: stretch;
            gap: 8px;
          }

          .top-info-group > div {
            justify-content: space-between;
          }

          .games-grid-card {
            padding: 20px 10px;
            gap: 24px !important;
            max-width: 100% !important;
          }

          .games-row-container {
            gap: 24px !important;
          }

          .game-icon-container {
            width: 120px;
            height: 120px;
            border-width: 3.5px;
          }

          .game-label {
            width: 135px;
            font-size: 12px;
            padding: 5px 10px;
            margin-top: -14px;
          }
        }

        @media (max-width: 768px) {
          html, body, #root {
            overflow-y: auto !important;
            height: auto !important;
            min-height: 100vh !important;
          }

          .casino-game-shell {
            height: auto !important;
            min-height: 100vh !important;
            overflow-y: visible !important;
            padding-bottom: 50px !important;
          }

          .main-content-wrapper {
            align-items: flex-start !important;
            padding-top: 15px !important;
            padding-bottom: 50px !important;
          }
        }

        /* Disclaimer Modal Luxury Styling */
        .royal-modal-card {
          background: linear-gradient(145deg, #181d28 0%, #0d1017 100%);
          border: 1px solid rgba(245, 175, 25, 0.4);
          box-shadow: 0 25px 60px rgba(0, 0, 0, 0.9), 0 0 35px rgba(245, 175, 25, 0.15);
        }

        .gold-title-gradient {
          background: linear-gradient(135deg, #ffffff 0%, #ffe066 40%, #f5af19 75%, #e59500 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .info-card-box {
          background: rgba(255, 255, 255, 0.04);
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 10px;
          padding: 10px 12px;
        }

        /* Accept Button - Rich Golden Royal Theme */
        .royal-btn-gold {
          background: linear-gradient(180deg, #ffe066 0%, #f5af19 50%, #d48b00 100%);
          color: #2e1700;
          font-weight: 900;
          letter-spacing: 0.8px;
          border: 1.5px solid #fff5b8;
          border-radius: 14px;
          cursor: pointer;
          box-shadow: 0 6px 20px rgba(245, 175, 25, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.85), inset 0 -2px 0 rgba(160, 95, 0, 0.4);
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          text-shadow: 0 1px 0 rgba(255, 255, 255, 0.45);
        }

        .royal-btn-gold:hover {
          background: linear-gradient(180deg, #fff5b8 0%, #ffdb4d 50%, #e69d00 100%);
          box-shadow: 0 8px 26px rgba(245, 175, 25, 0.7), 0 0 18px rgba(255, 215, 0, 0.55), inset 0 1px 0 rgba(255, 255, 255, 0.95);
          transform: translateY(-2px);
          color: #1a0d00;
        }

        .royal-btn-gold:active {
          transform: translateY(1px);
          box-shadow: 0 2px 10px rgba(245, 175, 25, 0.4);
        }
      `}</style>

      <div className="casino-game-shell" style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        color: 'white',
        fontFamily: '"Roboto", sans-serif',
        position: 'relative',
        background: 'transparent',
        overflowY: 'auto',
        overflowX: 'hidden'
      }}>
        {/* Sparkle Background */}
        <div className="sparkle-bg">
           {[...Array(60)].map((_, i) => (
             <div key={i} className="sparkle" style={{ 
               top: `${Math.floor(Math.random() * 100)}%`, 
               left: `${Math.floor(Math.random() * 100)}%`, 
               animationDelay: `${(Math.random() * 3).toFixed(2)}s`,
               width: Math.random() > 0.8 ? '4px' : '2px',
               height: Math.random() > 0.8 ? '4px' : '2px'
             }}></div>
           ))}
        </div>

        {/* Top Bar */}
        <div className="top-bar-container">
          {/* Left section: Name and Balance */}
          <div className="top-info-group">
            {/* Name */}
            <div style={{ display: 'flex', alignItems: 'center' }}>
               <span className="top-label">Name:</span>
               <div className="top-value">
                  {computer?.computer_code || "sagar001"}
               </div>
            </div>
            {/* Balance */}
            <div style={{ display: 'flex', alignItems: 'center' }}>
               <span className="top-label">Balance:</span>
               <div className="top-value">
                  {computer?.current_balance !== undefined ? computer.current_balance : "0"}
               </div>
            </div>
          </div>

          {/* Right section: Change Password & Close */}
          <div className="top-actions-group">
            <div onClick={handleLogout} style={{ 
                width: '40px', height: '40px', 
                background: 'linear-gradient(135deg, #ff4e00, #cc0000)', 
                borderRadius: '50%', 
                display: 'flex', justifyContent: 'center', alignItems: 'center', 
                color: 'white', fontWeight: 'bold', fontSize: '20px', 
                cursor: 'pointer', border: '2px solid #fff',
                boxShadow: '0 2px 8px rgba(0,0,0,0.8)' 
            }}>
              X
            </div>
            <button style={{ 
                background: 'linear-gradient(180deg, #ffe066, #f5af19)', 
                border: '1px solid #fff', 
                borderRadius: '20px', 
                padding: '8px 20px', 
                color: '#900', 
                fontWeight: '900', 
                fontSize: '14px',
                cursor: 'pointer', 
                boxShadow: '0 4px 8px rgba(0,0,0,0.6)' 
            }}>
              Change Password
            </button>
          </div>
        </div>

        {/* Main Content Area - The Grid */}
        <div className="main-content-wrapper" style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '16px 12px 28px',
          zIndex: 5
        }}>
          <div className="games-grid-card">
            {/* Top Row (5 items) */}
            <div className="games-row-container">
               <div className="game-item" onClick={openGame}>
                 <div className="game-icon-container">
                   <img src="/roulette_icon.jpg" alt="ROULETTE" className="game-icon" />
                 </div>
                 <div className="game-label">ROULETTE</div>
               </div>
               
               <div className="game-item" onClick={() => navigate("/fun-roulette")}>
                 <div className="game-icon-container">
                   <img src="/fun_roulette_wheel.jpg" alt="Lucky Gold" className="game-icon" />
                 </div>
                 <div className="game-label">Lucky Gold</div>
               </div>

               <div className="game-item" onClick={openGame}>
                 <div className="game-icon-container">
                   <img src="/roulette_mini_timer_icon.jpg" alt="ROULETTE MINI TIMER" className="game-icon" />
                 </div>
                 <div className="game-label">ROULETTE MINI<br/>TIMER</div>
               </div>

               <div className="game-item" onClick={openGame}>
                 <div className="game-icon-container">
                   <img src="/fun_target_icon.jpg" alt="FUN TARGET" className="game-icon" />
                 </div>
                 <div className="game-label">FUN TARGET</div>
               </div>

               <div className="game-item" onClick={openGame}>
                 <div className="game-icon-container">
                   <img src="/roulette_timer_icon.jpg" alt="ROULETTE TIMER" className="game-icon" />
                 </div>
                 <div className="game-label">ROULETTE TIMER</div>
               </div>
            </div>

            {/* Bottom Row (3 items) */}
            <div className="games-row-container">
               <div className="game-item" onClick={openGame}>
                 <div className="game-icon-container">
                   <img src="/fly_high_icon.jpg" alt="FLY HIGH" className="game-icon" />
                 </div>
                 <div className="game-label">FLY HIGH</div>
               </div>

               <div className="game-item" onClick={openGame}>
                 <div className="game-icon-container">
                   <img src="/andar_bahar_icon.jpg" alt="ANDAR BAHAR" className="game-icon" />
                 </div>
                 <div className="game-label">ANDAR BAHAR</div>
               </div>

               <div className="game-item" onClick={openGame}>
                 <div className="game-icon-container">
                   <img src="/teen_patti_icon.jpg" alt="TEEN PATTI" className="game-icon" />
                 </div>
                 <div className="game-label">TEEN PATTI</div>
               </div>
            </div>

          </div>
        </div>

                {/* PC Disclaimer Modal (VIP Casino Non-Scrollable) */}
        {showDisclaimer && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            zIndex: 9999,
            backgroundColor: 'rgba(5, 7, 12, 0.92)',
            backdropFilter: 'blur(16px)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '16px',
            boxSizing: 'border-box'
          }}>
            <div
              className="royal-modal-card"
              style={{
                borderRadius: '22px',
                maxWidth: '580px',
                width: '100%',
                padding: '24px 26px',
                color: '#f3f4f6',
                boxSizing: 'border-box',
                position: 'relative',
                overflow: 'hidden'
              }}
            >
              {/* Subtle ambient gold background glow inside card */}
              <div style={{
                position: 'absolute',
                top: '-50px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '240px',
                height: '120px',
                background: 'radial-gradient(ellipse at center, rgba(255, 215, 0, 0.15), transparent 70%)',
                pointerEvents: 'none'
              }}></div>

              {/* Header Icon Emblem */}
              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px', position: 'relative' }}>
                <div style={{
                  width: '56px',
                  height: '56px',
                  borderRadius: '50%',
                  background: 'radial-gradient(circle, #3d3215 0%, #171206 100%)',
                  border: '2px solid #E2B84F',
                  boxShadow: '0 0 25px rgba(226, 184, 79, 0.4)',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  position: 'relative'
                }}>
                  <i className="bi bi-shield-lock-fill" style={{ fontSize: '26px', color: '#FFD700', filter: 'drop-shadow(0 0 8px rgba(255, 215, 0, 0.6))' }}></i>
                  <span style={{
                    position: 'absolute',
                    bottom: '-2px',
                    right: '-2px',
                    background: 'linear-gradient(135deg, #ef4444, #dc2626)',
                    color: '#ffffff',
                    fontSize: '8px',
                    fontWeight: 'bold',
                    width: '18px',
                    height: '18px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '2px solid #0d1017',
                    boxShadow: '0 0 8px rgba(239, 68, 68, 0.6)'
                  }}>
                    18+
                  </span>
                </div>
              </div>

              {/* Header Text */}
              <div style={{ textAlign: 'center', marginBottom: '12px', position: 'relative' }}>
                <div style={{
                  fontSize: '10px',
                  fontWeight: '700',
                  letterSpacing: '2.5px',
                  color: '#E2B84F',
                  fontFamily: 'Cinzel, serif',
                  textTransform: 'uppercase',
                  marginBottom: '3px'
                }}>
                  ROYAL TERMINAL SECURITY AGREEMENT
                </div>
                <h2 className="gold-title-gradient" style={{
                  margin: 0,
                  fontSize: '23px',
                  fontWeight: '800',
                  letterSpacing: '0.5px',
                  lineHeight: '1.2'
                }}>
                  Terms & Disclaimer Notice
                </h2>
                <p style={{
                  margin: '4px 0 0 0',
                  fontSize: '11px',
                  color: '#94a3b8',
                  fontWeight: '500'
                }}>
                  Khel Apni Zimmewari Par Khele · Play Responsibly & At Your Own Risk
                </p>
              </div>

              <div style={{ borderBottom: '1px solid rgba(255,255,255,0.08)', marginBottom: '12px' }}></div>

              {/* Self Responsibility & No Real Money Notice Box */}
              <div style={{
                background: 'linear-gradient(135deg, rgba(70, 18, 28, 0.8) 0%, rgba(35, 10, 18, 0.9) 100%)',
                border: '1px solid rgba(248, 113, 113, 0.45)',
                boxShadow: '0 6px 20px rgba(0,0,0,0.4), inset 0 0 15px rgba(220, 38, 38, 0.1)',
                borderRadius: '14px',
                padding: '12px 14px',
                marginBottom: '12px',
                display: 'flex',
                gap: '12px',
                alignItems: 'flex-start'
              }}>
                <div style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '8px',
                  background: 'rgba(239, 68, 68, 0.25)',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexShrink: 0
                }}>
                  <i className="bi bi-exclamation-triangle-fill" style={{ fontSize: '16px', color: '#f87171' }}></i>
                </div>
                <div style={{ fontSize: '12px', lineHeight: '1.45', color: '#fecdd3' }}>
                  <div style={{ fontWeight: 'bold', color: '#fca5a5', fontSize: '13px', marginBottom: '2px' }}>
                    ⚠️ Aapni Zimmewari Par Khele (Self-Responsibility):
                  </div>
                  <div>
                    Yeh terminal games entertainment & point credits par aadharit hain. Kisi bhi loss, point risk ya decision ki <strong>poori zimmewari khiladi ki apni hogi</strong>.
                  </div>

                  {/* NO REAL MONEY HIGHLIGHT */}
                  <div style={{
                    marginTop: '6px',
                    paddingTop: '6px',
                    borderTop: '1px dashed rgba(239, 68, 68, 0.3)',
                    color: '#ffffff',
                    fontWeight: 'bold',
                    fontSize: '11px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px'
                  }}>
                    <span>🛡️</span>
                    <span>
                      <span style={{ color: '#f87171', fontWeight: '800' }}>NO REAL MONEY INVOLVED:</span> This game is strictly for amusement & entertainment ONLY. There is NO real money gambling or cash withdrawal involved.
                    </span>
                  </div>
                </div>
              </div>

              {/* Grid 2-Column Info Boxes */}
              <div className="disclaimer-grid">
                {/* Box 1: 18+ */}
                <div className="info-card-box">
                  <div style={{
                    color: '#fbbf24',
                    fontWeight: 'bold',
                    fontSize: '12px',
                    marginBottom: '3px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px'
                  }}>
                    <i className="bi bi-person-fill-lock" style={{ fontSize: '14px' }}></i> 18+ Age Verification
                  </div>
                  <div style={{ fontSize: '11px', color: '#94a3b8', lineHeight: '1.35' }}>
                    Kewal 18 saal ya usse adhik aayu ke log hi is terminal ko use karne ke liye authorized hain.
                  </div>
                </div>

                {/* Box 2: Server RNG */}
                <div className="info-card-box">
                  <div style={{
                    color: '#38bdf8',
                    fontWeight: 'bold',
                    fontSize: '12px',
                    marginBottom: '3px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px'
                  }}>
                    <i className="bi bi-cpu-fill" style={{ fontSize: '14px' }}></i> Server RNG Outcomes
                  </div>
                  <div style={{ fontSize: '11px', color: '#94a3b8', lineHeight: '1.35' }}>
                    Sabhi game rounds 100% server random logic dwara operate hote hain. Results final hain.
                  </div>
                </div>
              </div>

              {/* Box 3: Terminal Account Security */}
              <div className="info-card-box" style={{ marginBottom: '16px' }}>
                <div style={{
                  color: '#4ade80',
                  fontWeight: 'bold',
                  fontSize: '12px',
                  marginBottom: '3px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px'
                }}>
                  <i className="bi bi-key-fill" style={{ fontSize: '14px' }}></i> Terminal Account Security
                </div>
                <div style={{ fontSize: '11px', color: '#94a3b8', lineHeight: '1.35' }}>
                  Apna Computer ID & password kisi ko na dein. Terminal chhodne se pehle logout zaroor karein.
                </div>
              </div>

              {/* Action Button */}
              <button
                onClick={handleAcceptDisclaimer}
                className="royal-btn-gold"
                style={{
                  width: '100%',
                  padding: '14px',
                  borderRadius: '14px',
                  fontSize: '15px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '8px',
                  background: 'linear-gradient(180deg, #ffe066 0%, #f5af19 50%, #d48b00 100%)',
                  color: '#2e1700',
                  fontWeight: '900',
                  border: '1.5px solid #fff5b8',
                  boxShadow: '0 6px 20px rgba(245, 175, 25, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.85), inset 0 -2px 0 rgba(160, 95, 0, 0.4)',
                  cursor: 'pointer',
                  textShadow: '0 1px 0 rgba(255, 255, 255, 0.45)',
                  letterSpacing: '0.8px'
                }}
              >
                <i className="bi bi-check-circle-fill" style={{ fontSize: '18px', color: '#572b00' }}></i>
                I ACCEPT & AGREE (AAGE BADE)
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ComputerDashboard;





